import Default from './Default'
import Text from './Text'
import Path from './Path'
import Illustration from './Illustration'
import Image from './Image'
import MultiElement from './MultiElement'
class ToolboxItems {
  static Default = Default
  static StaticText = Text
  static DynamicText = Text
  static StaticPath = Path
  static StaticVector = Illustration
  static StaticImage = Image
  static DynamicImage = Image
  static MultiElement = MultiElement
}

export default ToolboxItems
